import {DATASET_MIXPANEL} from 'common/report/constants';

import {BaseClient} from '../utils/base-client';
import {getEventParam, processPropertyValues} from './utils';

class EventPropertyValuesClient extends BaseClient {
  buildEndpoint() {
    return `api/2.0/events/properties/values`;
  }

  buildQueryParams(params) {
    /* eslint-disable camelcase */
    return {
      project_id: params.projectId,
    };
    /* eslint-enable camelcase */
  }

  buildRequestBody({
    propertyName = null,
    customProperty = null,
    dataGroupPropertyName = null,
    eventName = null,
    datasetId = DATASET_MIXPANEL,
    dataGroupId = null,
    tempDataGroupId = null,
    workspaceId = null,
    specialErfParams = null, // only to be used by ERF, passes a flag and uses special params that behave differently in normal queries
    limit = null,
  }) {
    /* eslint-disable camelcase */
    return JSON.stringify({
      // Property could be of type array or string
      ...(propertyName ? {name: Array.isArray(propertyName) ? JSON.stringify(propertyName) : propertyName} : {}),
      ...(customProperty
        ? {property: JSON.stringify({...customProperty, ...(dataGroupPropertyName ? {dataGroupPropertyName} : {})})}
        : {}),
      ...getEventParam(eventName),
      ...(datasetId !== DATASET_MIXPANEL ? {dataset_name: datasetId} : {}),
      ...(dataGroupId ? {data_group_id: dataGroupId} : {}),
      ...(tempDataGroupId ? {temp_data_group_id: tempDataGroupId} : {}),
      ...(workspaceId ? {workspace_id: workspaceId} : {}),
      ...(limit ? {limit} : {}),

      ...(specialErfParams ? {...specialErfParams, erf_autodetection_query: true} : {}),
    });
    /* eslint-enable camelcase */
  }

  processResponse(response, {propertyName}) {
    return processPropertyValues(response, {propertyName});
  }
}

export const eventPropertyValuesClient = new EventPropertyValuesClient();
